export var TYPES = {
    AuthService: Symbol('AuthService'),
    CarrierService: Symbol('CarrierService'),
    CarrierGroupService: Symbol('CarrierGroupService'),
    UserService: Symbol('UserService'),
    RoleService: Symbol('roleService'),
    ProfileService: Symbol('ProfileService'),
    WamService: Symbol('WamService'),
    ReferenceDataService: Symbol('ReferenceDataService'),
    VacationService: Symbol('VacationService'),
    UtilsService: Symbol('UtilsService'),
    OpportunityService: Symbol('OpportunityService'),
    OpportunityActionsService: Symbol('OpportunityActionsService'),
    UpMarketLoadConfigService: Symbol('UpMarketLoadConfigService'),
    PartialSaveService: Symbol('PartialSaveService'),
    SupplierService: Symbol('SupplierService'),
    VendorService: Symbol('VendorService'),
    TcnService: Symbol('TcnService'),
    DummyTcnService: Symbol('DummyTcnService'),
    MaterialService: Symbol('MaterialService'),
    MaterialGroupService: Symbol('MaterialGroupService'),
    MaterialTypeService: Symbol('MaterialTypeService'),
    MaterialSynonymSrcService: Symbol('MaterialSynonymSrcService'),
    MaterialSynonymBolService: Symbol('MaterialSynonymBolService'),
    MaterialSynonymSapService: Symbol('MaterialSynonymSapService'),
    SiteService: Symbol('SiteService'),
    UserPreferenceService: Symbol('UserPreferenceService'),
    ContractManagementService: Symbol('ContractManagementService'),
    ContractTrackingService: Symbol('ContractTrackingService'),
};
